export default "__VITE_ASSET__CaYitXwT__"